import download from 'downloadjs';
import moment from 'moment';
export default {
	name: 'csvHelper',
	components: {
		download
	},
	data: {
		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
			//  var data = this.listStockReportData;
			var csvData = ''
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields Names
			csvfield.forEach(function(fields) {
				if (skipFilter.indexOf(fields.fieldColumn) == -1) {
					csvData += fields.fieldName + ','
				}
			});

			csvData = csvData.slice(0, csvData.length - 1)
			csvData += '\r\n'
			// CSV Data
			data.map(function(item) {
				var i = 0;
				var escapedCSV = ''
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						escapedCSV = item[key] + '' // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilder.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
							else
								csvData += escapedCSV + ','
						}
					}
					i++;
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n')
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/importCSV/importCSVHelper.js